/**
 * A federated partner's capability init defaults (Feature 48).
 *
 * Layer 3 of the capability InitAttr merge (defaults → global → THIS →
 * per-org → per-user). PUT is refused with 422 when the config carries a
 * field the global row does not open to the `partner` scope, or when
 * `field_scopes` carries a `partner` flag of its own.
 */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type {
  PartnerCapabilityConfig,
  UpsertGlobalConfigBody,
} from '../types.js';

export function listPartnerCapabilityConfigs(
  partnerId: string,
): Promise<PartnerCapabilityConfig[]> {
  return apiGet<PartnerCapabilityConfig[]>(
    `/api/v1/admin/partner-capability-configs/${partnerId}`,
  );
}

export function getPartnerCapabilityConfig(
  partnerId: string,
  capabilityId: string,
): Promise<PartnerCapabilityConfig> {
  return apiGet<PartnerCapabilityConfig>(
    `/api/v1/admin/partner-capability-configs/${partnerId}/${capabilityId}`,
  );
}

export function setPartnerCapabilityConfig(
  partnerId: string,
  capabilityId: string,
  body: UpsertGlobalConfigBody,
): Promise<PartnerCapabilityConfig> {
  return apiPut<PartnerCapabilityConfig>(
    `/api/v1/admin/partner-capability-configs/${partnerId}/${capabilityId}`,
    body,
  );
}

export function deletePartnerCapabilityConfig(
  partnerId: string,
  capabilityId: string,
): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/partner-capability-configs/${partnerId}/${capabilityId}`,
  );
}
